<template>
  <MainAsideRightHead
    :title="headTitle"
    store-path="usersGroups"
    :can-save="canSave"
    :options-visible="false"
    :save-text="saveText"
    :is-loading="loading"
    @save="save"
  />
</template>

<script>
import MainAsideRightHead from '@/components/MainAsideRight/MainAsideRightHead';
import { mapState } from 'vuex';

export default {
  components: { MainAsideRightHead },
  computed: {
    ...mapState('usersGroups', {
      canSave: s => s.aside.meta.canSave,
      group: s => s.aside.data.group,
      folder: s => s.aside.data.folder,
      loading: s => s.aside.meta.addingGroup || s.aside.meta.addingFolder || s.aside.meta.editingFolder
    }),
    isGroup() {
      return Object.keys(this.group).length;
    },
    isFolder() {
      return Object.keys(this.folder).length;
    },
    headTitle() {
      if (this.isGroup) {
        return this.group.id !== undefined ? 'Редактировать группу' : 'Добавить группу';
      } else if (this.isFolder) {
        return this.folder.id !== undefined ? 'Редактировать папку' : 'Добавить папку';
      }

      return undefined;
    },
    saveText() {
      if (this.isGroup) {
        return this.group.id !== undefined ? 'Сохранить' : 'Добавить';
      } else if (this.isFolder) {
        return this.folder.id !== undefined ? 'Сохранить' : 'Добавить';
      }

      return undefined;
    }
  },
  methods: {
    async save() {
      if (!this.canSave) {
        return;
      }

      if (this.isGroup) {
        if (this.group.id !== undefined) {
          await this.$store.dispatch('usersGroups/editGroup');
        } else {
          await this.$store.dispatch('usersGroups/addGroup');
        }
      } else if (this.isFolder) {
        if (this.folder.id !== undefined) {
          await this.$store.dispatch('usersGroups/editFolder');
        } else {
          await this.$store.dispatch('usersGroups/addFolder');
        }
      }

      this.closeAside();
    },
    closeAside() {
      this.$store.dispatch('usersGroups/setAsideMeta', {
        path: 'forceClose',
        value: true
      });
    }
  }
};
</script>
